// i18n 国际化，根布局，封装语言上下文环境
// 引入到 app/layout.tsx 中即可使用
// 额外增加了动态加载语言信息、语言信息未获取到的处理 demo

'use client';

import { useState } from 'react';
import { NextIntlClientProvider } from 'next-intl';

import en from '../../messages/en.json';
// import zh from '../../messages/zh.json';

import { LocaleProvider, useLocaleContext } from './locale-context';

import type { TLocals } from './config';

interface IProps {
    children: React.ReactNode;
}

interface ILocaleWrapperProps {
    children: React.ReactNode;
}

type TMessages = {
    [K in TLocals]: Record<string, Record<string, string>>;
};

// 包装组件处理语言切换
function I18nLayoutWrapper({ children }: ILocaleWrapperProps) {
    const { locale } = useLocaleContext();
    // 语言包映射 /message 文件下
    const [messages] = useState<TMessages>({
        en,
        // zh,
    });

    // 如 语种增加、语言包体积增加, 考虑 dynamic import OR Native loaded
    // 示例：在需要的时候加载语言文件
    // useEffect(() => {
    //     setTimeout(() => {
    //         fetch('http://127.0.0.1:5500/messages/zh.json')
    //             .then(response => response.json())
    //             .then(data => {
    //                 setAllMessages(prevMessages => ({ ...prevMessages, zh: data }));
    //             })
    //             .catch(error => {
    //                 console.error('Error fetching zh.json:', error);
    //             });
    //     }, 3000);
    // }, []);

    // 示例：如果消息还未加载完成，可以显示加载状态
    // if (Object.keys(messages).length === 0) {
    //     return <div>Loading...</div>;
    // }
    // 示例：如果找不到 messages[locale]，则返回错误信息
    // if (!messages[locale]) {
    //     return <div>Locale {locale} not found</div>;
    // }

    return (
        <NextIntlClientProvider timeZone='UTC' locale={locale} messages={messages[locale]}>
            {children}
        </NextIntlClientProvider>
    );
}

// 真正供 app/layout.tsx 使用的根布局组件
export default function I18NRootLayout({ children }: Readonly<IProps>) {
    return (
        <LocaleProvider>
            <I18nLayoutWrapper>{children}</I18nLayoutWrapper>
        </LocaleProvider>
    );
}
